module.exports = __webpack_public_path__ + "788522f6dda2a6a959dbc4cb7b7f8a4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/blurred-bg/blurred-bg-12.jpg
// module id = 385
// module chunks = 0